import React from 'react';
import {XMarkIcon} from '@heroicons/react/24/outline';

interface IEditorPreviewProps {
  html: string;
  onClose: () => void;
}

const EditorPreview = ({html, onClose}: IEditorPreviewProps) => {
  // TODO: implement craftjs editor enabled false instead of html
  // this will be the same as what user will see on dasar web
  return (
    <div className="fixed inset-0 z-50">
      <div id="preview-html" className="relative overflow-scroll" dangerouslySetInnerHTML={{__html: html}} />
      <button type="button" className="absolute top-2 right-2 bg-slate-500 p-2 rounded-full cursor-pointer hover:brightness-120" onClick={onClose}>
        <XMarkIcon className="size-5 text-white" />
      </button>
    </div>
  );
};

export default React.memo(EditorPreview);
